import {
  Table,
  useState,
  useDelete,
  useSearch,
  Breadcrumb,
  ErrorAlert,
  PageHero,
  DownloadExcel,
  SearchToggle,
  useFetchData,
  SmsBalanceAlert,
  useTableColumns,
  TableRowsPerPage,
  ChatBubbleLeftRightIcon,
} from "@";
import { getMessages } from "./utils/api";
import { useResendMessage } from "./utils/hooks";
import MultiSearch from "./components/MultiSearch";
import ResendMultiMessages from "./components/ResendMultiMessages";
import { searchValues, excelHeaderCellsName } from "./utils/options";
import { TableActions, tableColumns } from "./components/TableOptions";

const Index = () => {
  // Breadcrumb links
  const links = [{ name: " المراسلات السابقة", link: "" }];
  const [isSmsBalanceLow, setIsSmsBalanceLow] = useState(true);

  // Search state and handler
  const { search, updateSearch } = useSearch(searchValues);

  // Fetch data state and handler
  const { data, setData, isLoading, error, pg, fetchData, updatePg } =
    useFetchData({
      fun: getMessages,
      params: [search.values],
    });

  // Delete handler
  const { deleteHandler } = useDelete(data, setData, "messages");

  // Resend message handlers
  const { sendSingle, sendMulti } = useResendMessage(setData, fetchData);

  // Table columns configuration
  const columns = useTableColumns(tableColumns, (row) => (
    <TableActions
      row={row}
      deleteHandler={deleteHandler}
      handelResendSingle={sendSingle}
      isSmsBalanceLow={isSmsBalanceLow}
    />
  ));

  // SMS balance handler
  const getSmsBalance = (value) => setIsSmsBalanceLow(value);

  return (
    <>
      {/* Error alert */}
      <ErrorAlert reload={fetchData} show={error} />
      <SmsBalanceAlert isShow={getSmsBalance} />
      <Breadcrumb links={links} />

      <main className="table-card relative">
        <PageHero
          eyebrow="الرسائل"
          title="المراسلات السابقة"
          count={pg.rows}
          icon={ChatBubbleLeftRightIcon}
          hideCount={isLoading}
        >
          <TableRowsPerPage
            pagination={pg}
            onRowsPerPageChange={(size) => updatePg({ size: size })}
          />

          <DownloadExcel
            fetch={getMessages}
            length={data?.length}
            search={search.values}
            headerCellsName={excelHeaderCellsName}
          />

          <ResendMultiMessages
            sendMulti={sendMulti}
            dataLength={data?.length}
            isSmsBalanceLow={isSmsBalanceLow}
          />

          <SearchToggle toggle={() => updateSearch({ show: !search.show })} />
        </PageHero>

        {/* Multi Search inputs */}
        <MultiSearch
          search={search}
          onSubmit={fetchData}
          updateSearch={updateSearch}
        />

        {/* Table */}
        <Table
          data={data}
          pagination={pg}
          columns={columns}
          isLoading={isLoading}
          pageChange={(page) => updatePg({ page: page })}
          perRowsChange={(size) => updatePg({ size: size })}
        />
      </main>
    </>
  );
};

export default Index;
